import React from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import { Image } from '@/components/Image';
import { GeoLocation } from '@/types/schema';

import useLocationImage from '../hooks/useLocationImage';
import ViewMapButton from '../ViewMapButton';
import { locationPreviewImageStyles } from './styles';

function LocationPreview({
  geoLocation,
  containerClassName,
  className,
}: {
  geoLocation: GeoLocation;
  className?: string;
  containerClassName?: string;
}) {
  const { locationImageUrl, containerRef } = useLocationImage({ geoLocation });

  if (!locationImageUrl) {
    return null;
  }

  return (
    <Box ref={containerRef} className={cn('relative', containerClassName)}>
      <Image
        alt={geoLocation.addressLine1 ?? ''}
        className={cn('mt-8 w-full rounded-8', className, locationPreviewImageStyles)}
        layout="fill"
        src={locationImageUrl}
      />
      <ViewMapButton geoLocation={geoLocation} />
    </Box>
  );
}

export default LocationPreview;
